<template>
    <div class="page">
        <div class="userinfo-wrap">
                <div class="avatar"></div>
            <div class="flex-group flex-center">
                <div class="account yellow">
                  {{userInfo.name || userInfo.mobile}}
                  <span @click="goto('info')">
                    <img style="width: 20px;vertical-align: middle;" src="../assets/edit.png" />
                  </span>
                </div>
            </div>
            <!-- <div class="flex-group flex-around">
                <div class="month-rank">{{userInfo.ranking}}</div>
                <div class="quarter-rank">{{userInfo.ranking_quarter}}</div>
                <div class="score-wrap yellow">
                    <img class="s-icon" src="~@/assets/s-icon.png" alt=""> {{userInfo.score}}
                </div>
            </div> -->

        </div>
        <div class="uc-content">
          <div class="menu-wrap">
              <div class="menu-item" @click="goto('contentlist')">
                <!-- <img src="../assets/ct1.png"> -->
              </div>
              <div class="menu-item" @click="goto('myqs')">
                  <em class="question-count" v-if="userInfo.question_count"> {{userInfo.question_count}}</em>
                  <!-- <img src="../assets/ct2.png"> -->
              </div>
              <div class="menu-item" @click="goto('comingsoon')">
                <!-- <img src="../assets/ct3.png"> -->
              </div>
              <div class="menu-item" @click="goto('setting')">
                <!-- <img src="../assets/ct4.png"> -->
              </div>
          </div>
        </div>
        <img width="100%" src="../assets/ft-bg.png">
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Ucenter',
    data(){
        return {
            id: '',
            name: '',
            mobile: '',
            score: 0,
            ranking: 0,
            list: [],

            showSharePop: false,
            shareUrl: 'http://qs.wobangta.com/#/share',
            shareTitle: '',
            shareDesc: '',
            questionId: this.$route.query.id
        }
    },
    computed: {
        ...mapState(['userInfo','lang','langMap'])
    },
    created(){
      this.mobile = this.$route.query.msisdn;
      if (this.mobile){
        this._loginAction();
      }else{
        this._fetchInfo();
      }
    },
    methods: {
        ...mapActions(['setUserInfo']),
        _loginAction(){
          let reqData = {mobile: this.mobile, password: this.passwd}
          Utils.$ajax({
            type: 'post',
            url: '/login/login',
            data: reqData,
          }).done(res=>{
            if(res.code==0){
              this.setUserInfo(res.data);
              localStorage.A_uuid = res.data.uuid;
              localStorage.A_token = res.data.token;
            }else if(res.code==4401){
              this.$router.push(`/land`);
            }else{
              this.$toast(res.msg);
            }
          })
        },
        _fetchInfo(){
          let that = this;
            Utils.$ajax({
                url: '/user/info',
                type: 'post',
            }).done(res =>{
                this.loaded = true;
                if (res.code == 0 ){
                  this.setUserInfo(res.data);
                }else if(res.code == 4401){
                  that.$router.push(`/land`);
                }
            })
        },
        goto(page){
            this.$router.push(page);
        }
    }
}
</script>

<style lang="scss" scoped>
    .userinfo-wrap{
        margin: 0 auto;
        width: rem(693);
        height: rem(288);
        padding: rem(0) rem(60) rem(60);
        // background: url('~@/assets/u-bg.png') no-repeat;
        background-size: contain;
        .avatar{
            width: rem(210);
            height:rem(210);
            background: url(~@/assets/u-icon.png) 0 0 no-repeat;
            background-size: contain;
            border-radius: 50%;
            margin: 0 auto;
            // border: 2px #fff solid;
        }
        .account{
          text-align: center;
          padding:20px 0;
          border-radius: 30px 30px 0 0;
          width: 80%;
          background: #fff;
          color:#4b7cff;
          margin-top: rem(45);
        }
        .score-wrap{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .s-icon{
                width: rem(52);
                height: rem(52);
                margin-right: 3px;
            }
        }
        .month-rank{
            width: rem(181);
            height: rem(72);
            background: url(~@/assets/rank-bg-1.png) no-repeat center center /contain;
            padding-left: rem(70);
            line-height: rem(86);
            color: #ffff66;
            font-weight: bold;
        }
        .quarter-rank{
            width: rem(203);
            height: rem(84);
            background: url(~@/assets/rank-bg-2.png) no-repeat center center /contain;
            color: #fff;
            font-weight: bold;
            padding-left: rem(90);
            line-height: rem(88);
        }
    }

        .uc-content{
          background: #fff;
        }
    .menu-wrap{
        display: flex;
        width: rem(741);
        height: rem(660);
        margin:rem(70) auto 0;
        background: url('~@/assets/menu.png') center center/contain no-repeat;
        justify-content: space-between;
        flex-wrap: wrap;
        .menu-item{
            position: relative;
            width: rem(370);
            height: rem(330);
            margin-bottom: rem(70);
        }
        .question-count{
            position: absolute;
            color: #fff;
            font-size: rem(28);
            right: rem(50);
            top: rem(70);
            background: #f44238;
            border-radius: rem(70);
            height: rem(36);
            line-height: rem(36);
            width: rem(36);
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Ucenter.vue